/* Shopify Forms owns field values, validation, and submission. This adds layout and accessible labels only. */
if (!customElements.get('swe-sponsored-riders')) {
  customElements.define('swe-sponsored-riders', class extends HTMLElement {
    connectedCallback() {
      this.attempts = 0;
      this.watchForm();
    }
    disconnectedCallback() { clearTimeout(this.timer); this.observer?.disconnect(); }
    watchForm() {
      if (!this.isConnected) return;
      const root = this.querySelector('shopify-forms-embed')?.shadowRoot;
      if (root) {
        const update = () => {
          const loaded = root.querySelector('form, [role="status"]');
          if (loaded) this.querySelector('[data-riders-loading]').hidden = true;
          this.formatForm(root);
        };
        this.observer = new MutationObserver(update);
        this.observer.observe(root, { childList: true, subtree: true });
        update();
      } else if (this.attempts++ < 120) this.timer = setTimeout(() => this.watchForm(), 250);
    }

    formatForm(root) {
      const form = root.querySelector('form');
      if (!form) return;
      if (!root.querySelector('#swe-riders-form-style')) {
        const style = document.createElement('style');
        style.id = 'swe-riders-form-style';
        style.textContent = `
          :host { --inline-container-max-width: 100%; --forms-base-font-size: 16px; }
          [data-testid="form"] { gap: 20px; }
          .swe-riders-field { display:flex!important; flex-direction:column; min-width:0; }
          .swe-riders-field::before { content:none!important; }
          .swe-riders-field > label { position:static!important; transform:none!important; order:-1; white-space:normal!important; font-size:14px!important; line-height:1.5!important; margin:0 0 8px!important; padding:0!important; color:#20473b!important; max-width:100%!important; overflow:visible!important; }
          .swe-riders-field > input,.swe-riders-field > textarea { padding:13px!important; font-size:16px!important; line-height:1.5!important; width:100%; box-sizing:border-box; min-height:50px; }
          .swe-riders-field > textarea { min-height:120px; resize:vertical; }
          .swe-riders-field > input:focus-visible,.swe-riders-field > textarea:focus-visible { outline:2px solid #20473b!important; outline-offset:3px; }
          .swe-riders-phone { align-items:flex-end!important; }
          .swe-riders-field-label { font-size:14px!important; line-height:1.5!important; }
          .swe-riders-required { color:#a62120; font-size:12px; }
          .swe-riders-optional { color:#60655f; font-size:12px; font-weight:400; }
          .swe-riders-group { grid-column:1/-1; color:#20473b; font-size:22px; line-height:1.2; font-weight:700; letter-spacing:-.035em; padding-top:30px; margin:14px 0 0; border-top:1px solid #20473b30; }
          .swe-riders-group:first-of-type { border:0; padding-top:0; margin-top:0; }
        `;
        root.append(style);
      }
      const required = new Set([
        'first_name', 'email', 'last_name', 'custom#riders_full_name',
        'custom#who_is_completing_this_application', 'custom#riders_age_band', 'custom#city', 'custom#us_state',
        'custom#which_riding_disciplines_do_you_compete_in', 'custom#your_competition_level',
        'custom#tell_us_about_your_horses_and_a_typical_riding_week',
        'custom#which_accomplishments_are_you_proudest_of_include_events_and_dat',
        'custom#what_competitions_and_goals_are_on_your_calendar',
        'custom#what_does_your_content_feel_like_and_what_swe_content_would_you_',
        'custom#how_often_do_you_post_now_and_what_product-posting_schedule_coul',
        'custom#why_swe_tell_us_how_you_approach_horse_care_sportsmanship_and_au',
        'custom#application_acknowledgment'
      ]);
      const mark = (label, key) => {
        if (!label || label.querySelector('[data-swe-field-status]')) return;
        const note = document.createElement('span');
        note.dataset.sweFieldStatus = '';
        note.className = required.has(key) ? 'swe-riders-required' : 'swe-riders-optional';
        note.textContent = required.has(key) ? ' *' : ' · optional';
        label.append(note);
      };
      for (const input of form.querySelectorAll('input:not([type="hidden"]):not([type="checkbox"]), textarea')) {
        const key = input.id || input.name;
        if (!key) continue;
        const label = root.getElementById(`label-${key}`);
        if (!label) continue;
        // Shopify's multi-line controls supply name but omit id, leaving their labels disconnected.
        if (!input.id) input.id = key;
        if (input.getAttribute('aria-labelledby') !== label.id) input.setAttribute('aria-labelledby', label.id);
        input.setAttribute('aria-required', String(required.has(key)));
        input.parentElement.classList.add('swe-riders-field');
        if (key === 'phone_number') input.parentElement.parentElement.classList.add('swe-riders-phone');
        mark(label, key);
      }
      for (const key of ['custom#who_is_completing_this_application', 'custom#riders_age_band', 'custom#your_competition_level']) {
        const label = root.getElementById(`${key}-selector-label`);
        if (label) { label.classList.add('swe-riders-field-label'); mark(label, key); }
      }
      mark(form.querySelector('fieldset[name="custom#application_acknowledgment"] legend'), 'custom#application_acknowledgment');
      const groups = [
        ['first_name', '01 / Your details'],
        ['custom#which_riding_disciplines_do_you_compete_in', '02 / Your riding'],
        ['custom#tiktok_profile_link', '03 / Your audience'],
        ['custom#what_does_your_content_feel_like_and_what_swe_content_would_you_', '04 / Your partnership']
      ];
      for (const [key, title] of groups) {
        const input = root.getElementById(key);
        if (!input) continue;
        let field = input;
        while (field.parentElement && field.parentElement !== form) field = field.parentElement;
        if (field.parentElement !== form || field.previousElementSibling?.dataset.sweGroup === key) continue;
        const heading = document.createElement('h3');
        heading.className = 'swe-riders-group';
        heading.dataset.sweGroup = key;
        heading.textContent = title;
        field.before(heading);
      }
    }
  });
}
